import { render, staticRenderFns } from "./DismissAll.vue?vue&type=template&id=61f7100e&scoped=true&"
import script from "./DismissAll.vue?vue&type=script&lang=js&"
export * from "./DismissAll.vue?vue&type=script&lang=js&"
import style0 from "./DismissAll.vue?vue&type=style&index=0&id=61f7100e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f7100e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61f7100e')) {
      api.createRecord('61f7100e', component.options)
    } else {
      api.reload('61f7100e', component.options)
    }
    module.hot.accept("./DismissAll.vue?vue&type=template&id=61f7100e&scoped=true&", function () {
      api.rerender('61f7100e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/General/Header/Notifications/DismissAll.vue"
export default component.exports